export const isSameUrl = (firstUrl: string, secondUrl: string): boolean => {
  const firstUrlQuery = firstUrl.split('?');
  const secondUrlQuery = secondUrl.split('?');

  if (firstUrlQuery[0] !== secondUrlQuery[0]) return false;

  const firstUrlParams = Object.fromEntries(new URLSearchParams(firstUrlQuery[1]).entries());
  const secondUrlParams = Object.fromEntries(new URLSearchParams(secondUrlQuery[1]).entries());

  for (let param in secondUrlParams) {
    if (firstUrlParams[param] !== secondUrlParams[param]) return false;
  }

  return true;
};

export const getRandomNumber = (min: number = 1000000, max: number = 9999999): number => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
};

export const pipe =
  (...operations) =>
  (input) =>
    operations.reduce((output, operation) => operation(output), input);

declare const window: any;
export const clientVersion = window.DD_VERSION;
